/*
 * the model only handles data, in this case
 * it is used to retrieve data with ajax and expose it to the controller
 * and return a promise on a finished ajax request
 */

// import { AjaxLoader } from './../../js/ajax-loader';
import { tryParseJSON, createElementFromHTML } from './../../js/helper';

class ModelFinderModel {
    constructor ($modelFinder) {
        this.$form = $modelFinder.querySelector('[data-model-finder="form"]');
        this.ajaxData = null;
        this.clickedStepNumber = 0;
        this.newStepsAndOptions = [];
        // this.newStepsAndOptions example with data:
        //     Step 1   ,         Step 2
        // [['option 1'], ['option 1', 'option 2']]
        this.activeStepNumber = 0;
    }

    requestData (filterItem) {
        let formData;

        if (filterItem === undefined) {
            formData = undefined;
        } else {
            formData = this.createFormData(filterItem);
        }

        const method = this.$form.getAttribute('method');
        const action = this.$form.getAttribute('action');

        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open(method, action, true);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.onload = () => {
                const result = xhr.responseText;

                if (xhr.status >= 200 && xhr.status < 400) {
                    const jsonData = tryParseJSON(result);

                    if (jsonData !== false) {
                        this.ajaxData = jsonData;
                        this.generateStepsAndOptionsArray();
                        resolve();
                    } else {
                        const errorMessage = new Error('not a valid json string');
                        reject(errorMessage);
                    }
                } else {
                    reject(xhr);
                }
            };

            xhr.send(formData);
        });
    }

    // create FormData from the first step till the clicked step
    // and NOT from the whole form
    createFormData (filterItem) {
        // do not use FormData.entries(), it does not work with IE11
        // and the polyfill sucks and is not necessary
        const customData = new FormData();
        const $radios = this.$form.querySelectorAll('[data-model-finder="radio"]');
        const endKey = filterItem.name;

        for (let i = 0; i < $radios.length; i++) {
            const $radio = $radios[i];
            const key = $radio.name;
            const value = $radio.value;

            if ($radio.checked) {
                customData.append(key, value);
            }

            // stop after clicked radio to prevent sending complete form
            if ($radio.checked && key === endKey) {
                break;
            }
        }

        const $hiddenInputs = this.$form.querySelectorAll('input[type="hidden"]');

        for (let i = 0; i < $hiddenInputs.length; i++) {
            customData.append($hiddenInputs[i].name, $hiddenInputs[i].value);
        }

        return customData;
    }

    // create an array which contains each new step with their representative options
    generateStepsAndOptionsArray () {
        const filterMarkup = this.ajaxData.filter;
        // if only the configurator only has one step, the createElementFromHTML
        // won't return an array, but an HTMLElement
        // therefore we have to catch this exception check for an array
        // before calling slice()
        const $filter = createElementFromHTML(filterMarkup);
        let steps = [];

        if (Array.isArray($filter)) {
            steps = $filter.slice(this.clickedStepNumber);
        }

        // clear array
        this.newStepsAndOptions.length = 0;

        for (let i = 0; i < steps.length; i++) {
            const $currentStep = steps[i];

            if ($currentStep.classList.contains('model-finder__step--disabled')) {
                break;
            }

            // wrapper which contains input + label
            const $options = $currentStep.querySelectorAll('[data-model-finder="option"]');
            const optionCollection = [];

            for (let j = 0; j < $options.length; j++) {
                const $currentOption = $options[j];
                optionCollection.push($currentOption);
            }

            this.newStepsAndOptions.push(optionCollection);
        }
        // console.log('ModelFinderModel -> collectOptions -> this.newStepsAndOptions', this.newStepsAndOptions);
    }
}

export { ModelFinderModel };
